<template>
  <div class="w-full">
    <div class="text-sm text-center mx-auto mt-4" :style="tabWidth">
      <span>
        {{ 'Remaining storage: ' }}
        <strong>
          <span class="text-pink">{{ remaining > 0 ? remaining : 0 }}GB</span> /
          {{ totalStorage ?? 100 }}GB</strong
        >
      </span>
      <br />
      <span
        v-if="showStorageAlert"
        class="
          flex flex-col
          items-center
          justify-center
          text-grey-600
          -ml-2
          mt-4
        "
      >
        <div class="text-red font-semibold text-sm">
          <span
            >{{
              $t('frontend_groovevideo_videos_fileupload_low_sorage_left', {
                add: !hasOwnStorage
                  ? $t('frontend_groovevideo_videos_fileupload_add_own_storage')
                  : '',
              })
            }}
          </span>
        </div>
        <span
          class="text-pink underline cursor-pointer mt-1"
          @click="goToStorageSettings"
          v-if="!hasOwnStorage"
          >{{
            $t('frontend_groovevideo_videos_fileupload_go_to_storage_settings')
          }}</span
        >
      </span>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    totalStorage: {
      default() {
        return 100;
      },
    },
    remaining: {
      default() {
        return 100;
      },
    },
    hasOwnStorage: {
      default: false,
    },
    tabWidth: {},
  },
  data() {
    return {};
  },
  computed: {
    showStorageAlert() {
      const percentage = (this.remaining / this.totalStorage) * 100;
      return percentage <= 20;
    },
  },
  methods: {
    goToStorageSettings() {
      this.$router.push({ name: 'settings', hash: '#ownStorage' });
    },
  },
};
</script>